import React from 'react';

import { AppDispatch } from 'types/redux';
import { IProviderList } from 'types/provider';
import { TParamsColumns } from 'types/params';

import { TSetRequestError } from './snackbar';

export const checkDataAndFileTypeBeforeDownloadHandler =
  (
    type: string,
    providerList: IProviderList,
    setExportType: React.Dispatch<React.SetStateAction<string>>,
    showSettingsModal: React.Dispatch<React.SetStateAction<boolean>>,
    downloadReport: (type: string, columns?: TParamsColumns) => void,
    setRequestError: TSetRequestError
  ) =>
  (dispatch: AppDispatch) => {
    if (providerList.data.length > 0) {
      setExportType(type);
      if (type === 'csv') showSettingsModal(true);
      else downloadReport(type);
    } else {
      dispatch(
        setRequestError('Нет данных для формирования файла выгрузки', true)
      );
    }
  };
